import { render, staticRenderFns } from "./settleInfo.vue?vue&type=template&id=2bd6b6f7&"
import script from "./settleInfo.vue?vue&type=script&lang=js&"
export * from "./settleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports